export default __webpack_public_path__ + "static/media/claudia.b93c683e.png";